import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// helpers
import { getJsonFromUrl } from "helpers";

// actions
import * as Actions from "actions";

// component
import WrapperCartPage from "../component/WrapperCartPage";

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  getCartById: (...args) => dispatch(Actions.getCartById(...args)),
});
class CartPage extends Component {
  static propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    const { location } = this.props;
    const urlParams = getJsonFromUrl(location);
    this.state = {
      urlParams,
      cartID: urlParams.id,
      loading: true,
    };
  }

  componentDidMount() {
    this.refresh();
  }

  async refresh() {
    const { cartID } = this.state;
    const { getCartById } = this.props;

    const resp = await getCartById(cartID);
    this.setState({ cart: resp.payload, loading: false });
  }

  render() {
    const { location, history } = this.props;

    const { urlParams, loading, cart } = this.state;

    return (
      <WrapperCartPage
        history={history}
        cart={cart}
        location={location}
        urlParams={urlParams}
        loading={loading}
      />
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CartPage);
